// Where the Usage demo lives: under the superadmin demo routes, reached from
// the Slack messages' buttons; no nav entry.

export const USAGE_PATH = "/superadmin/demo/usage";
export const usageProjectPath = (projectId: string) => `${USAGE_PATH}/project/${projectId}`;
/** What a later intake collects: a change to the playbook, the vendor's answer for the next round, the signed agreement, or the reason the deal is cancelled. */
export type IntakeStage = "revision" | "proposal" | "cancel" | "dismiss";
/** The intake the negotiation starts with; with a stage, the one a later step opens. */
export const usageIntakePath = (projectId: string, stage?: IntakeStage) =>
    `${usageProjectPath(projectId)}/intake${stage ? `?for=${stage}` : ""}`;
